import { Row, Col } from 'src/componentes/grid';
import { FormattedMessage } from 'react-intl';

import Table from 'src/componentes/table';
import Button from 'src/componentes/button';
import LucideIcon from 'src/componentes/lucide-icon';
import IconButton from 'src/componentes/icon-button';
import { capitalizeFirstLetter } from 'src/utils/string';
import useAuth from 'src/hooks/useAuth';

const ItensAssociados = ({ model, allowNew, handleNewClick }) => {
  const { terms: resources } = useAuth();

  const handleRemove = (index) => {
    let novaLista = model.value;
    novaLista.splice(index, 1);
    model.requestChange(novaLista);
  };

  const getTipo = (string) => {
    let tipo = '';

    for (let i = 0; i < string.length; i++) {
      const char = string[i];

      if (char != '{' && char != '}') tipo += char;
    }

    return tipo;
  };

  return (
    <div>
      <Row>
        <Col md={6}>
          {model.label && (
            <label className="control-label">{model.label}</label>
          )}
        </Col>
        <Col md={6}>
          {allowNew && (
            <Button
              className="pull-right"
              type="primary"
              style={{ marginBottom: 10, padding: '6px 12px' }}
              onClick={handleNewClick}
            >
              <LucideIcon icon="Search" size={13} className="mr-2" />
              <FormattedMessage id="label.buscar" />
            </Button>
          )}
        </Col>
      </Row>
      {model.value && model.value.length > 0 ? (
        <Table>
          <thead>
            <tr>
              <th>
                <FormattedMessage id="nome" />
              </th>
              <th>
                <FormattedMessage id="label.tipoDoItem" />
              </th>
              <th>{capitalizeFirstLetter(resources.responsaveis)}</th>
              <th>{capitalizeFirstLetter(resources.area)}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {model.value &&
              model.value.map((item, index) => (
                <tr key={index}>
                  <td>{item.nome}</td>
                  <td>
                    {item.tipo &&
                      capitalizeFirstLetter(
                        item.tipoNome
                          ? item.tipoNome
                          : resources[getTipo(item.tipo.descricao)]
                      )}
                  </td>
                  <td>{item.responsaveis}</td>
                  <td>{item.area}</td>
                  <td style={{ width: 40 }}>
                    {allowNew && (
                      <IconButton
                        icon="close-circle"
                        className="clarear"
                        onClick={() => handleRemove(index)}
                      />
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      ) : (
        <i>
          <FormattedMessage id="label.naoHaItensRelacionados" />
        </i>
      )}
    </div>
  );
};

export default ItensAssociados;
